<mat-select [formControl]="skjemakontroll" [compareWith]="erValgt" panelClass="velg-generert-dokument--alternativer" [placeholder]="placeholder" class="e2e-generertdokument" #dokumentvelger>
  <mat-select-tips>
    {{ "Inkluder et dokument der innholdet blir generert av systemet. Du kan laste opp saksdokumenter når du har opprettet sakene ved å dra-og-slippe de over saken eller bruke menyen"|translate }}
  </mat-select-tips>
  @for (dokument of tilgjengeligeDokumenter; track dokument.type) {
    <mat-option [value]="dokument.type">{{ dokument.navn }}</mat-option>
  }
</mat-select>
